export default __webpack_public_path__ + "static/media/both-filled.7af80d5f.svg";